// This file contains only the QuickSight integration logic
// It assumes the SDK has already been loaded via a script tag in the HTML
// https://unpkg.com/amazon-quicksight-embedding-sdk@2.9.0/dist/quicksight-embedding-js-sdk.min.js

/* global QuickSightEmbedding */

import { flashMessages } from 'core/helpers/flash_messages.js';

export async function initializeQuickSightEmbed(embedUrl, panelOptions = {}, onMessage = null, throwError = false, container = "#quicksight-embed") {
  try {
    // Context
    const embeddingContext = await QuickSightEmbedding.createEmbeddingContext();

    // Iframe configurations
    const frameOptions = {
      url: embedUrl,
      container: container,  // Use the passed container
      width: "100%",
      height: "38px" // Initial search bar height
    };

    const defaultPanelOptions = {
      panelType: 'SEARCH_BAR',
      focusedHeight: "400px",    // Height when dropdown is open
      expandedHeight: "700px"     // Height when showing answers
    };

    const contentOptions = {
      panelOptions: Object.keys(panelOptions).length > 0 ? panelOptions : defaultPanelOptions,
      showTopicName: false,
      showPinboard: false,
      allowTopicSelection: false,
      allowFullscreen: true,
      searchPlaceholderText: window.translations.searchPlaceholder,
      onMessage: onMessage
    };

    window.embeddedQnA = await embeddingContext.embedGenerativeQnA(frameOptions, contentOptions);

  } catch (error) {
    if (throwError) {
      throw error;
    }

    flashMessages.setFlash(window.translations.errorMessage, 'danger');
  }
}

window.initializeQuickSightEmbed = initializeQuickSightEmbed;
